import React from 'react';
import featureToggle from '../../../featureToggle.json';
import DateOptions from '../../../layouts/DateOptions';
import usersService from '../../../axios/usersService';
import Dev from '../../dev/Dev';
import { Flex } from '@aws-amplify/ui-react';
import { useEffect, useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useIdleTimer } from '../../../utils/IdleTimer';
import { FiltersContext } from '../../../components/Navigation/Routes';
import { SigmaEmbed } from '../../../layouts/SigmaEmbed';
import { Spin } from 'antd';

export const Home = ({ page }) => {
  const context = useContext(FiltersContext);
  const { channel, switchOn, setSwitchOn, impersonatorInfo } = context;

  const environment = process.env.REACT_APP_ENVIRONMENT;

  const [checked, setChecked] = useState(true);
  const [switchDisabled, setSwitchDisabled] = useState(true);

  useIdleTimer(channel);

  if (featureToggle[environment][page]) {
    return (
      <Flex direction={'row'} height={'100%'}>
        <Flex
          direction={'column'}
          width={'100%'}
          height={'100%'}
          overflow={'hidden'}
        >
          {page === 'home' ? (
            <Flex
              direction={'row'}
              justifyContent={'space-between'}
            >
              <Flex direction={'row'} alignItems={'center'} marginLeft={'22px'}>
                <div className="acc-home-title">BUSINESS REVIEW</div>
              </Flex>
              <Flex
                paddingTop={'12px'}
                paddingBottom={'5px'}
              >
                <DateOptions
                  page={page}
                  checked={checked}
                  setChecked={setChecked}
                  switchOn={switchOn}
                  setSwitchOn={setSwitchOn}
                  switchDisabled={switchDisabled}
                  setSwitchDisabled={setSwitchDisabled}
                />
              </Flex>
            </Flex>
          ) : null}
          <SigmaEmbed page={page} />
        </Flex>
      </Flex>
    );
  } else {
    return <Dev />;
  }
};
